import React, { Component } from 'react';
import * as recharge from '@rechargeapps/storefront-client';
import _ from "lodash";
import PropTypes from "prop-types";
import CryptoTool from "../../../utils/CryptoTool";
import {
  initRecharge,
  getCDNProduct,
  getCDNProductAndSettings,
  getDynamicBundleItems,
  listCollectionProducts,
  loginShopifyAppProxy,
  listBundleSelections,
  getCDNProducts,
  loadBundleData
} from '@rechargeapps/storefront-client';
import API from "../../../utils/API";
import { addProductToCart, clearCart } from "../../../utils/shopifyUtils";
import { getMealsBreakdown, markNewMeals, bubbleUpSKU, calculateDeliveryDateFromNow, getSellingProgramSellingPlan, setDefaultUser } from "../../../utils/functions";
import {
  filterOutMeals,
  markExcluded,
  saveUserSelectionToLocalStorage,
  pushItemToCartObject,
  populateSKUs,
  groupExcludeCodes,
  markHidden,
  updateNavLink,
  getConstructorModeFromClient,
  populateMealsTitlesAndQuantities,
  populateMealsHandles,
  populateExcludedCodes,
  filterExcludeCodes,
  setSelectedMealsMark,
  getFLExcludes,
  getCMExcludes,
} from "./utils";
import { logSentryError } from "../../../utils/sentryLogger";
import ContentWrap from "./../../organisms/ContentWrap";
import AddIns from "./../../organisms/AddIns";
import Sidebar from "./../../organisms/Sidebar";
import ProgressBarUncontrolled from "./../../molecules/ProgressBarUncontrolled";
import ContentInner from "./../../organisms/ContentInner";
import MealSettings from "../../organisms/MealSettings";
import MealList from "./../../organisms/MealList";
import SkeletonLoader from "./../../molecules/Skeleton";
import ErrorMessage from "./../../atoms/ErrorMessage";
import { getBundleId, getShopDomain, getRechargeToken } from '../../../constants/bundleConfig';


const shopUrl = CryptoTool.getShopUrl();
const apiUrl = CryptoTool.getApiUrl();
const DefaultUser = CryptoTool.getDefaultUser();

const processImageUrl = (img) => {
  if (!img) return '';

  if (typeof img === 'object' && img.src) {
    const imgSrc = img.src;
    if (typeof imgSrc === 'string') {
      return imgSrc.startsWith('//') ? 'https:' + imgSrc : imgSrc;
    }
    return '';
  }

  if (typeof img === 'string') {
    return img.startsWith('//') ? 'https:' + img : img;
  }
  return '';
};

class MealSelectorContent extends React.Component {
  // bundleHandleByDiet = {
  //   'Mediterranean Plan': 'mediterranean-bundle',
  //   'Low-FODMAP Plan': 'low-fodmap-bundle',
  //   'Diabetes Plan': 'diabetes-bundle',
  //   'Gluten-Free Plan': 'gluten-free-bundle',
  //   'Heart-Friendly Plan': 'heart-friendly-bundle',
  //   'Carb-Conscious Plan': 'carb-conscious-bundle',
  //   'B2B Plan': 'b2b-bundle',
  //   'Care Plan': 'care-bundle',
  //   'GLP-1 Plan': 14898064785772,
  // };

  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      step: 1,
      exclusions: [],
      diets: [],
      breakfasts: [],
      entrees: [],
      bundles: [],
      deliveryDate: "",
      additionals: [],
      selectedExclusions: [],
      selectedMeals: {
        breakfasts: [],
        entrees: [],
      },
      selectedAddIns: [],
      selectedDiet: "All diets",
      selectedProgram: "HF-Program",
      dietType: "Heart-Friendly Plan",
      cart: {
        products: [],
        bundles: [],
        cartQuantity: 0,
      },
      dietitian: { support: false, id: "", price: "" },
      limitations: {
        breakfastsMinLimit: 0,
        entreesMinLimit: 0,
        additionalMealsMinLimit: {
          breakfastsMinLimit: 0,
          entreesMinLimit: 0,
        },
      },
      charge: {},
      toCart: false,
      configPageUrl: "",
      sticky: false,
      compactHeader: false,
      programType: "",
      errorMessage: "",
    };
    this.lastScrollTop = 0;
    this.wrapRef = React.createRef();
    this.innerRef = React.createRef();
  }

  componentDidMount() {
    const { mode } = this.props;

    if (mode === "constructor") {
      this.getDataNewOrder();
    } else {
      this.getAccountModeData();
    }

    this.setState({
      deliveryDate: calculateDeliveryDateFromNow(),
    });
  }

  componentDidUpdate = (prevProps) => {
    const { mode } = this.props;
    if (mode !== "constructor") {
      if (prevProps.upcomingDeliveryMeals.length !== this.props.upcomingDeliveryMeals.length) {
        this.getAccountModeData();
      }
    }
  };


  async getDataNewOrder() {
    const constructorObject = await getConstructorModeFromClient();
    this.setState({ constructorObject });

    await this.getBundlesDataSDK();
    await this.getProductsData();
  }

  fetchMealSellingPlan = async (shopifyProductId, shopDomain) => {
    try {
      const url = `https://static.rechargecdn.com/store/${shopDomain}/products/${shopifyProductId}/2021-08`;
      const response = await fetch(url);

      if (!response.ok) {
        const text = await response.text();
        return null;
      }

      const data = await response.json();
      const plan = data.product?.plans?.[0];

      if (plan?.external_plan_id) {
        return plan.external_plan_id;
      }

      return null;
    } catch (error) {
      return null;
    }
  };

  handleToCheckoutClick = async (clearCartFlag) => {
    try {
      const deliveryDate = calculateDeliveryDateFromNow();
      const dietType = this.state.dietType;
      const _bundles = this.state.bundles;
      const _exclusions = [...this.state.exclusions];
      const _selectedExclusions = [...this.state.selectedExclusions];
      const breakfasts = [...this.state.selectedMeals.breakfasts];
      const entrees = [...this.state.selectedMeals.entrees];
      const _selectedAddIns = this.state.selectedAddIns.map((addIn) => {
        addIn.id = addIn.variants[0].id;
        return addIn;
      });

      let exclusionSkuPrefix;
      if (getFLExcludes(this.state.dietType)) {
        exclusionSkuPrefix = "FL-";
      } else if (getCMExcludes(this.state.dietType)) {
        exclusionSkuPrefix = "CM-";
      } else {
        exclusionSkuPrefix = "MD-";
      }

      let { excludeCodes, freshLean } = populateExcludedCodes(
        _exclusions,
        _selectedExclusions,
        exclusionSkuPrefix
      );

      const bundleProduct = _bundles[0]?.product;

      const breakfastsCollection = this.state.bundleCollections?.find(col =>
        /breakfast/i.test(col.title)
      );
      const entreesCollection = this.state.bundleCollections?.find(col =>
        /entree/i.test(col.title)
      );

      const bundleVariant = bundleProduct.variants?.[0];
      const shopDomain = getShopDomain();

      // Build bundle configuration
      const bundle = {
        externalProductId: String(bundleProduct.shopify_product_id || bundleProduct.id),
        externalVariantId: String(bundleVariant.shopify_variant_id || bundleVariant.id),
        selections: []
      };

      // Add breakfasts
      for (const meal of breakfasts) {
        const originalMeal = this.state.breakfasts.find(m => m.id === meal.id);
        let sellingPlan = originalMeal?.selling_plan_groups?.[0]?.selling_plans?.[0]?.id;

        if (!sellingPlan) {
          const shopifyProductId = meal.shopify_product_id ||
            meal.shopifyProductId ||
            meal.product_id ||
            meal.productId;

          if (shopifyProductId) {
            sellingPlan = await this.fetchMealSellingPlan(shopifyProductId, shopDomain);
          }
        }

        bundle.selections.push({
          collectionId: String(breakfastsCollection.id),
          externalProductId: String(meal.shopify_product_id || meal.id),
          externalVariantId: String(meal.variants[0]?.shopify_variant_id || meal.variants[0]?.id),
          quantity: meal.quantity,
          sellingPlan: sellingPlan
        });
      }

      // Add entrees
      for (const meal of entrees) {
        const originalMeal = this.state.entrees.find(m => m.id === meal.id);
        const originalMealByHandle = !originalMeal ?
          this.state.entrees.find(m => m.handle === meal.handle) : null;

        const foundMeal = originalMeal || originalMealByHandle;

        let sellingPlan = foundMeal?.selling_plan_groups?.[0]?.selling_plans?.[0]?.id;

        if (!sellingPlan) {
          const shopifyProductId = meal.shopify_product_id ||
            meal.shopifyProductId ||
            meal.product_id ||
            meal.productId;

          if (shopifyProductId) {
            sellingPlan = await this.fetchMealSellingPlan(shopifyProductId, shopDomain);
          }
        }

        bundle.selections.push({
          collectionId: String(entreesCollection.id),
          externalProductId: String(meal.shopify_product_id || meal.id),
          externalVariantId: String(meal.variants[0]?.shopify_variant_id || meal.variants[0]?.id),
          quantity: meal.quantity,
          sellingPlan: sellingPlan
        });
      }

      // Get bundle items from Recharge
      const bundleItems = await getDynamicBundleItems(bundle, bundleProduct.handle);

      // Ensure all items have selling plans
      const variantToSellingPlan = {};
      bundle.selections.forEach(selection => {
        variantToSellingPlan[selection.externalVariantId] = selection.sellingPlan;
      });

      const bundleItemsWithPlans = bundleItems.map((item) => {
        const sellingPlan = item.selling_plan || variantToSellingPlan[item.id];
        return {
          ...item,
          selling_plan: sellingPlan
        };
      });

      const variantIdToSku = {};

      [...breakfasts, ...entrees].forEach(meal => {
        const variantId = String(meal.variants[0]?.shopify_variant_id || meal.variants[0]?.id);
        const originalMeal = [...this.state.breakfasts, ...this.state.entrees].find(
          om => om.id === meal.id || om.handle === meal.handle
        );
        const sku = originalMeal?.variants[0]?.sku || meal.variants[0]?.sku || '';

        if (variantId && sku) {
          variantIdToSku[variantId] = `${sku}:${meal.quantity}`;
        }
      });

      // Add custom properties with individual SKU only
      const itemsToAdd = bundleItemsWithPlans.map((item, index) => {
        const individualSku = variantIdToSku[item.id] || '';

        // Custom properties for each item
        const customProperties = {
          _exclude_codes: excludeCodes,
          _fresh_lean: freshLean,
          _SKU: individualSku,
          _shipping_interval_frequency: '1',
          _shipping_interval_unit_type: 'Weeks'
        };

        // Merge Recharge properties with custom properties
        const mergedProperties = {
          ...(item.properties || {}),  // Preserve _rc_bundle_* from Recharge
          ...customProperties
        };

        return {
          id: item.id,
          quantity: item.quantity,
          selling_plan: item.selling_plan,
          properties: mergedProperties
        };
      });

      // Add selected add-ins
      if (!clearCartFlag && _selectedAddIns.length > 0) {
        const addInItems = _selectedAddIns.map(addIn => ({
          id: String(addIn.id),
          quantity: addIn.quantity,
          properties: {
            _SKU: addIn.skuList,
            _shipping_interval_frequency: '1',
            _shipping_interval_unit_type: 'Weeks'
          },
          selling_plan: getSellingProgramSellingPlan(this.state.dietType)
        }));
        itemsToAdd.push(...addInItems);
      }

      // Add dietitian if selected
      if (this.state.dietitian.support) {
        const dietitianItem = {
          id: String(this.state.dietitian.id),
          quantity: 1,
          properties: {
            _shipping_interval_frequency: '1',
            _shipping_interval_unit_type: 'Weeks'
          },
          selling_plan: getSellingProgramSellingPlan(this.state.dietType)
        };
        itemsToAdd.push(dietitianItem);
      }

      // Update state and add to cart
      this.setState({
        cart: {
          products: itemsToAdd,
          bundles: [],
          cartQuantity: breakfasts.reduce((sum, m) => sum + m.quantity, 0) +
            entrees.reduce((sum, m) => sum + m.quantity, 0)
        }
      }, () => {
        clearCart(() => {
          const payload = { items: itemsToAdd };

          if (process.env.NODE_ENV === "production") {
            API.post("/cart/add.js", JSON.stringify(payload))
              .then((response) => {
                return API.get("/cart.js");
              })
              .then((cartResponse) => {

                const cartAttributes = {
                  attributes: {
                    deliveryDate: deliveryDate || '',
                    dietType: dietType || ''
                  }
                };

                return API.post("/cart/update.js", JSON.stringify(cartAttributes));
              })
              .then(() => {
                window.location.href = "/cart";
              })
              .catch((error) => {
                console.error(error);
                this.setState({
                  errorMessage: error.response?.data?.description || "Failed to add items to cart."
                });
                logSentryError(error);
              });
          }
        });
      });

    } catch (error) {
      console.error(error);
      this.setState({
        errorMessage: error.message || "Failed to prepare checkout."
      });
      logSentryError(error);
    }
  };

  getBundlesDataSDK = async () => {
    try {
      const SHOP_DOMAIN = getShopDomain();
      const RECHARGE_TOKEN = getRechargeToken();
      if (!RECHARGE_TOKEN) {
        this.setState({
          bundles: [],
          breakfasts: [],
          entrees: []
        });
        return;
      }

      initRecharge({
        storeIdentifier: SHOP_DOMAIN,
        storefrontAccessToken: RECHARGE_TOKEN,
        appName: 'ModifyHealth',
        appVersion: '1.0.0'
      });

      const constructorObject = this.state.constructorObject;
      const dietType = constructorObject?.dietType || this.state.dietType || 'GLP-1 Plan';
      const bundleKey = getBundleId(dietType);

      const bundleProduct = await loadBundleData(String(bundleKey), {
        source: 'online_store'
      });

      if (!bundleProduct?.collections) {
        this.setState({ errorMessage: 'No collections', bundles: [], breakfasts: [], entrees: [] });
        return;
      }

      const bundleSellingPlan = bundleProduct.selling_plan_groups?.[0]?.selling_plans?.[0];

      const bundleCollections = [];
      let breakfasts = [];
      let entrees = [];

      for (const collectionId in bundleProduct.collections) {
        const collection = bundleProduct.collections[collectionId];
        const isBreakfast = /breakfast/i.test(collection.title || '');

        const items = (collection.products || []).map(product => {
          const variant = product.variants?.[0];
          const image = product.featured_image || product.images?.[0] || '';
          const mealSellingPlanGroups = product.selling_plan_groups ||
            (bundleSellingPlan ? [{
              selling_plans: [bundleSellingPlan]
            }] : []);

          return {
            id: variant?.id || product.id,
            collectionId: collectionId,
            title: product.title,
            handle: product.handle,
            skuList: variant?.sku ? `${variant.sku}:1` : '',
            quantity: 0,
            price: variant?.price || 0,
            image: processImageUrl(image),
            images: product.images || [],
            variants: variant ? [{
              id: variant.id,
              sku: variant.sku,
              price: variant.price,
              shopify_product_id: product.external_product_id?.ecommerce || product.shopify_product_id || product.id,
              shopify_variant_id: variant.shopify_variant_id
            }] : [],
            type: isBreakfast ? 'breakfast' : 'entrée',
            tags: product.tags || [],
            description: product.description || '',
            selling_plan_groups: mealSellingPlanGroups,
            shopify_product_id: product.external_product_id?.ecommerce || product.shopify_product_id || product.id
          };
        });

        bundleCollections.push({
          id: collectionId,
          title: collection.title,
          handle: collection.handle,
          items: items
        });

        if (isBreakfast) {
          breakfasts.push(...items);
        } else {
          entrees.push(...items);
        }
      }
      const selectedMealsWithQ = constructorObject?.selectedMeals ?
        setSelectedMealsMark(constructorObject.selectedMeals, { meals: [...breakfasts, ...entrees] }, constructorObject) :
        { breakfasts: [], entrees: [] };

      this.setState({
        bundles: [{ product: bundleProduct }],
        bundleCollections,
        breakfasts,
        entrees,
        bundleTitle: bundleProduct.title,
        isLoaded: true,
        errorMessage: '',
        limitations: constructorObject?.limitations || {
          breakfastsMinLimit: 0,
          entreesMinLimit: 0,
          additionalMealsMinLimit: {
            breakfastsMinLimit: 0,
            entreesMinLimit: 0,
          },
        },
        selectedExclusions: constructorObject?.selectedExclusions || [],
        selectedDiet: constructorObject?.selectedDiet || "All diets",
        selectedProgram: constructorObject?.selectedProgram || "HF-Program",
        dietType: constructorObject?.dietType || dietType,
        selectedAddIns: constructorObject?.selectedAddIns || [],
        selectedMeals: selectedMealsWithQ,
        configPageUrl: constructorObject?.configPageUrl || "",
        dietitian: constructorObject?.dietitian || { support: false, id: "", price: "" },
        programType: constructorObject?.programType || ""
      }, () => {
        if (this.state.exclusions.length > 0) {
          this.filterProductsWithExclusions();
        }
        if (this.props.mealSettings?.diets && this.state.diets.length > 1) {
          this.filterProductsWithDiet();
        }
        if (constructorObject?.dietType && constructorObject.dietType !== "Low-FODMAP Plan") {
          updateNavLink(constructorObject.dietType);
        }
      });

    } catch (e) {
      this.setState({
        errorMessage: e?.message || 'Error loading bundle data',
        bundles: [], breakfasts: [], entrees: []
      });
    }
  };

  async getProductsData() {
    const constructorObject = this.state.constructorObject;
    const mealSettings = this.props.mealSettings;
    const dietEnabled = mealSettings.diets;
    const addInsEnabled = mealSettings.addIns;

    setDefaultUser();

    const { id: customerId, email: customerEmail } = window.shopifyUser || {};

    const mealConstructorCollections = this.props.mealConstructorCollections;
    const exclusionCollectionId = mealConstructorCollections?.exclusionsCollectionId;
    const additionalCollectionId = mealConstructorCollections?.additionalCollectionId;

    if (!exclusionCollectionId) {
      this.setState({
        exclusions: [],
        diets: [{ id: "0", name: "All diets" }],
        additionals: []
      });
      return;
    }

    let productUrl = `${shopUrl}/api/products?exclusionCollectionId=${exclusionCollectionId}`;

    if (additionalCollectionId) {
      productUrl += `&additionalCollectionId=${additionalCollectionId}`;
    }

    productUrl += `&customer_id=${customerId}`;

    let constructorData;
    try {
      const cryptedUrl = CryptoTool.cryptUrl(productUrl, customerEmail);
      const response = await API.get(cryptedUrl);

      constructorData = {
        exclusions: response.data.exclusions || [],
        diets: response.data.diets || [],
        additionals: response.data.additionals || []
      };

    } catch (error) {
      console.error("API FAILED:", error.response?.status, error.response?.data);

      constructorData = {
        exclusions: [],
        diets: [],
        additionals: [],
      };
    }

    let _diets = constructorData.diets || [];
    if (_diets.length === 0) {
      _diets = [{ id: "0", name: "All diets" }];
    } else {
      _diets.unshift({ id: "0", name: "All diets" });
    }

    this.setState({
      exclusions: constructorData.exclusions || [],
      diets: dietEnabled === false ? [] : _diets,
      additionals: addInsEnabled === false ? [] : (constructorData.additionals || []),
    }, () => {
      if (this.state.exclusions.length > 0) {
        this.filterProductsWithExclusions();
      }

      if (dietEnabled && this.state.diets.length > 1) {
        this.filterProductsWithDiet();
      }

      if (constructorObject?.dietType && constructorObject.dietType !== "Low-FODMAP Plan") {
        updateNavLink(constructorObject.dietType);
      }
    });
  }

  getAccountModeData = async () => {
    const { additionals, exclusions, diets, charge, editSubscription, passedDownExlusions, upcomingDeliveryMeals, dietType } = this.props;

    if (!charge || !charge.meals) {
      this.setState({
        isLoaded: true,
        errorMessage: 'Unable to load delivery data'
      });
      return;
    }

    try {
      let _charge = { ...charge };
      let dietTitle = dietType || _charge.main_title;

      // Load full bundle data to get ALL available meals
      const SHOP_DOMAIN = getShopDomain();
      const RECHARGE_TOKEN = getRechargeToken();

      if (!RECHARGE_TOKEN) {
        this.setState({
          isLoaded: true,
          errorMessage: 'Missing configuration'
        });
        return;
      }

      initRecharge({
        storeIdentifier: SHOP_DOMAIN,
        storefrontAccessToken: RECHARGE_TOKEN,
        appName: 'ModifyHealth',
        appVersion: '1.0.0'
      });

      const bundleKey = getBundleId(dietTitle);
      const bundleProduct = await loadBundleData(String(bundleKey), {
        source: 'online_store'
      });

      if (!bundleProduct?.collections) {
        this.setState({
          isLoaded: true,
          errorMessage: 'No meal collections available'
        });
        return;
      }

      // Build full breakfast and entree lists from bundle collections
      let allBreakfasts = [];
      let allEntrees = [];

      for (const collectionId in bundleProduct.collections) {
        const collection = bundleProduct.collections[collectionId];
        const isBreakfast = /breakfast/i.test(collection.title || '');

        const items = (collection.products || []).map(product => {
          const variant = product.variants?.[0];
          const image = product.featured_image || product.images?.[0] || '';

          return {
            id: variant?.id || product.id,
            collectionId: collectionId,
            title: product.title,
            handle: product.handle,
            skuList: variant?.sku ? `${variant.sku}:1` : '',
            quantity: 0,
            price: variant?.price || 0,
            image: processImageUrl(image),
            images: product.images || [],
            variants: variant ? [{
              id: variant.id,
              sku: variant.sku,
              price: variant.price,
              shopify_product_id: product.external_product_id?.ecommerce || product.shopify_product_id || product.id,
              shopify_variant_id: variant.shopify_variant_id
            }] : [],
            type: isBreakfast ? 'breakfast' : 'entrée',
            tags: product.tags || [],
            description: product.description || '',
            selling_plan_groups: product.selling_plan_groups || [],
            shopify_product_id: product.external_product_id?.ecommerce || product.shopify_product_id || product.id
          };
        });

        if (isBreakfast) {
          allBreakfasts.push(...items);
        } else {
          allEntrees.push(...items);
        }
      }

      // get selected meals from charge
      let selectedBreakfasts = filterOutMeals(_charge.meals, ["breakfast"], dietTitle);
      let selectedEntrees = filterOutMeals(_charge.meals, ["entrée"], dietTitle);
      let selectedAddIns = filterOutMeals(_charge.meals, ["add-in"], dietTitle);

      selectedBreakfasts = selectedBreakfasts.map(selected => {
        const fullMeal = allBreakfasts.find(meal =>
          meal.variants[0]?.sku === selected.variants[0]?.sku ||
          meal.title === selected.title
        );

        if (fullMeal) {
          return {
            ...fullMeal,
            quantity: selected.quantity,
            subscriptionId: selected.subscriptionId
          };
        }
        return selected;
      });

      selectedEntrees = selectedEntrees.map(selected => {
        const fullMeal = allEntrees.find(meal =>
          meal.variants[0]?.sku === selected.variants[0]?.sku ||
          meal.title === selected.title
        );

        if (fullMeal) {
          return {
            ...fullMeal,
            quantity: selected.quantity,
            subscriptionId: selected.subscriptionId
          };
        }
        return selected;
      });

      let editedNewBreakfasts = editSubscription.breakfasts;
      let editedNewEntrees = editSubscription.entrees;

      const dietEnabled = window.mealSettings?.diets || false;
      const addInsEnabled = window.mealSettings?.addIns || false;

      this.setState(
        {
          isLoaded: true,
          exclusions: [...exclusions],
          diets: dietEnabled ? [...diets] : [],
          breakfasts: allBreakfasts,
          entrees: allEntrees,
          additionals: addInsEnabled ? [...additionals] : [],
          selectedExclusions: passedDownExlusions,
          selectedMeals: {
            breakfasts: [...selectedBreakfasts],
            entrees: [...selectedEntrees],
          },
          selectedAddIns: selectedAddIns,
          selectedDiet: "All meals",
          dietType: dietTitle,
          dietitian: { support: false, id: "", price: "" },
          limitations: {
            breakfastsMinLimit: editedNewBreakfasts,
            entreesMinLimit: editedNewEntrees,
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
            },
          },
          charge: { ..._charge },
          configPageUrl: "",
          programType: "",
        },
        () => {
          this.filterProductsWithExclusions();
          if (dietEnabled) {
            this.filterProductsWithDiet();
          }
        }
      );

    } catch (error) {
      this.setState({
        isLoaded: true,
        errorMessage: error.message || 'Failed to load meal data'
      });
    }
  };

  setQty = (obj, _obj) => {
    if (obj.id === _obj.id && obj.quantity > 0) {
      obj.quantity = _obj.quantity;
    }
  };

  saveMeals = (data, mode) => {
    this.setState(
      {
        selectedMeals: data,
      },
      () => {
        if (mode === "constructor") {
          saveUserSelectionToLocalStorage(this.state);
        }
      }
    );
  };

  handleMealChange = (item) => {
    const self = this;
    const { mode } = this.props;
    const _item = { ...item };

    const originalMeal = this.state.breakfasts.find(m => m.id === _item.id) ||
      this.state.entrees.find(m => m.id === _item.id);

    if (originalMeal?.shopify_product_id && !_item.shopify_product_id) {
      _item.shopify_product_id = originalMeal.shopify_product_id;
    }

    let _newSelectedMeals = _.cloneDeep(this.state.selectedMeals),
      productType = _item.type === "breakfast" ? "breakfasts" : "entrees",
      mealExists = _newSelectedMeals[productType].findIndex((meal) => meal.id === _item.id);
    if (mealExists >= 0) {
      _newSelectedMeals[productType].forEach(function (meal) {
        self.setQty(meal, _item);
      });
    } else {
      _newSelectedMeals[productType].push(_item);
    }
    _newSelectedMeals[productType] = _.remove(_newSelectedMeals[productType], (el) => el.quantity > 0);
    this.saveMeals(_newSelectedMeals, mode);
  };

  handleAddInsChange = (item) => {
    const self = this;
    const { mode } = this.props;
    const _item = { ...item };
    let newSelectedAddIns = [...this.state.selectedAddIns],
      mealExists = newSelectedAddIns.findIndex((meal) => meal.id === _item.id);
    if (mealExists >= 0) {
      newSelectedAddIns.forEach(function (meal) {
        self.setQty(meal, _item);
      });
    } else {
      newSelectedAddIns.push(_item);
    }
    newSelectedAddIns = _.remove(newSelectedAddIns, (data) => data.quantity > 0);
    newSelectedAddIns.forEach(function (meal) {
      let sku = meal.skuList.split(":")[0];
      meal.skuList = sku + ":" + meal.quantity;
    });
    this.saveMeals(newSelectedAddIns, mode);
  };

  handleExclusionChange = (e, reference) => {
    const { mode } = this.props;
    let newExlusions = [...this.state.selectedExclusions],
      change = reference.checked === true ? "add" : "delete",
      value = e.target.value;
    if (change === "add") {
      if (newExlusions.indexOf(value) === -1) {
        newExlusions.push(value);
      } else {
        _.remove(newExlusions, (item) => item === value);
      }
    } else {
      _.remove(newExlusions, (item) => item === value);
    }
    newExlusions = _.uniq(newExlusions);
    this.setState(
      {
        selectedExclusions: newExlusions,
      },
      () => {
        this.filterProductsWithExclusions(this.state);
        if (mode === "constructor") {
          saveUserSelectionToLocalStorage(this.state);
        }
      }
    );
  };

  handleDietChange = (e) => {
    const { mode } = this.props;
    this.setState(
      {
        selectedDiet: e.target.value,
      },
      () => {
        this.filterProductsWithDiet();
        if (mode === "constructor") {
          saveUserSelectionToLocalStorage(this.state);
        }
      }
    );
  };

  hadleClearAll = (e, type) => {
    let _selectedMeals = { ...this.state.selectedMeals };
    _selectedMeals[type] = [];
    this.setState({
      selectedMeals: _selectedMeals,
    });
  };

  handleDeleteItem = (id, type) => {
    const { mode } = this.props;
    let productType = type === "breakfast" ? "breakfasts" : "entrees",
      _selectedMeals = { ...this.state.selectedMeals },
      meals = _selectedMeals[productType];
    _.remove(meals, (item) => item.id === id);
    _selectedMeals[productType] = meals;
    this.saveMeals(_selectedMeals, mode);
  };

  handleDietitianChange = (e) => {
    const { mode } = this.props;
    this.setState(
      {
        dietitian: {
          support: e.checked,
          id: e.value,
          price: this.state.dietitian.price,
        },
      },
      () => {
        if (mode === "constructor") {
          saveUserSelectionToLocalStorage(this.state);
        }
      }
    );
  };

  handleCompactModeClick = () => {
    this.setState({
      compactHeader: !this.state.compactHeader,
    });
  };

  filterProductsWithDiet = () => {
    let _breakfasts = [...this.state.breakfasts],
      _entrees = [...this.state.entrees],
      _diets = [...this.state.diets],
      _diet = this.state.selectedDiet,
      _filteredOutDiets = [];
    _filteredOutDiets = _diets.map((diet) => _diet !== diet.name && _diet !== "None");
    let breakfastsMarked = markHidden(_breakfasts, this.state);
    let entreesMarked = markHidden(_entrees, this.state);
    this.setState({
      breakfasts: breakfastsMarked,
      entrees: entreesMarked,
    });
  };

  filterProductsWithExclusions = () => {
    let _breakfasts = [...this.state.breakfasts],
      _entrees = [...this.state.entrees],
      _selectedBreakfasts = [...this.state.selectedMeals.breakfasts],
      _selectedEntrees = [...this.state.selectedMeals.entrees],
      _selectedExclusions = [...this.state.selectedExclusions];
    let breakfastsMarked = markExcluded(_breakfasts, _selectedExclusions),
      entreesMarked = markExcluded(_entrees, _selectedExclusions),
      userBreakfastsMarked = markExcluded(_selectedBreakfasts, _selectedExclusions),
      userEntreesMarked = markExcluded(_selectedEntrees, _selectedExclusions);
    this.setState({
      breakfasts: breakfastsMarked,
      entrees: entreesMarked,
      selectedMeals: {
        breakfasts: userBreakfastsMarked,
        entrees: userEntreesMarked,
      },
    });
  };

  handleCTAClick = () => {
    const { mode } = this.props;
    if (mode === "constructor") {
      const { additionals } = this.state;
      if (!additionals.legnth) {
        this.handleToCheckoutClick(true);
      } else {
        this.setState({
          step: 2,
        });
      }
    } else {
      const { additionals } = this.props;
      if (!additionals.legnth) {
        this.handleSaveCharge();
      } else {
        this.setState({
          step: 2,
        });
      }
    }
  };

  handleBackClick = () => {
    this.setState({
      step: 1,
    });
  };


  handlePrevClick = () => {
    this.props.handlePrevClick();
  };

  handleClickEditQuantity = () => {
    this.props.handleClickEditQuantity();
  };

  handleSaveCharge = async () => {
    const { selectedAddIns, selectedExclusions, selectedMeals } = this.state;
    const { customerId, redirectEditQuantity, charge, exclusions, main_title } = this.props;

    const deliveryDate = calculateDeliveryDateFromNow();
    const dietType = this.state.dietType;
    const _bundles = this.state.bundles;
    const _exclusions = [...this.state.exclusions];
    const _selectedExclusions = [...this.state.selectedExclusions];
    const breakfasts = [...this.state.selectedMeals.breakfasts];
    const entrees = [...this.state.selectedMeals.entrees];
    const _selectedAddIns = this.state.selectedAddIns.map((addIn) => {
      addIn.id = addIn.variants[0].id;
      return addIn;
    });

    const meals = _.concat(selectedMeals.breakfasts, selectedMeals.entrees, selectedAddIns);
    let _charge = { ...charge };
    const filteredExcludeCodes = filterExcludeCodes(exclusions, selectedExclusions);
    const addressId = _charge.addressId;

    let exclusionSkuPrefix;
    if (typeof main_title !== "undefined") {
      if (getFLExcludes(main_title)) {
        exclusionSkuPrefix = "FL-";
      } else if (getCMExcludes(main_title)) {
        exclusionSkuPrefix = "CM-";
      } else {
        exclusionSkuPrefix = "MD-";
      }
    } else {
      if (getFLExcludes(this.state.dietType)) {
        exclusionSkuPrefix = "FL-";
      } else if (getCMExcludes(this.state.dietType)) {
        exclusionSkuPrefix = "CM-";
      } else {
        exclusionSkuPrefix = "MD-";
      }
    }

    let { excludeCodes, freshLean } = populateExcludedCodes(
      _exclusions,
      _selectedExclusions,
      exclusionSkuPrefix
    );

    const bundleProduct = _bundles[0]?.product;

    const breakfastsCollection = this.state.bundleCollections?.find(col =>
      /breakfast/i.test(col.title)
    );
    const entreesCollection = this.state.bundleCollections?.find(col =>
      /entree/i.test(col.title)
    );

    const mealsBreakdown = getMealsBreakdown(_charge.meals);
    const savedMealsBreakdown = getMealsBreakdown(meals);
    let newMeals = markNewMeals(mealsBreakdown, savedMealsBreakdown, meals, _charge.meals);
    newMeals = bubbleUpSKU(newMeals);

    const shopDomain = getShopDomain();
    const bundleSellingPlan = this.state.bundles?.[0]?.product?.selling_plan_groups?.[0]?.selling_plans?.[0]?.id;

    const cleanedMealsPromises = newMeals.map(async (meal) => {
      const mealWithPlan = selectedMeals.breakfasts.find(m => m.id === meal.id) ||
        selectedMeals.entrees.find(m => m.id === meal.id) ||
        selectedAddIns.find(m => m.id === meal.id);

      let sellingPlan = mealWithPlan?.selling_plan_groups?.[0]?.selling_plans?.[0]?.id;

      if (!sellingPlan) {
        const shopifyProductId = meal.shopify_product_id ||
          meal.variants[0]?.shopify_product_id ||
          mealWithPlan?.shopify_product_id;

        if (shopifyProductId) {
          sellingPlan = await this.fetchMealSellingPlan(shopifyProductId, shopDomain);

          if (!sellingPlan) {
            sellingPlan = mealWithPlan?.selling_plan;

            if (!sellingPlan && meal.selling_plan) {
              sellingPlan = meal.selling_plan;
            }

            if (!sellingPlan) {
              const fullMeal = this.state.breakfasts.find(m => m.id === meal.id) ||
                this.state.entrees.find(m => m.id === meal.id);
              sellingPlan = fullMeal?.selling_plan_groups?.[0]?.selling_plans?.[0]?.id;
            }

            if (!sellingPlan && bundleSellingPlan) {
              sellingPlan = bundleSellingPlan;
            }
          }
        }
      }

      let collectionId = mealWithPlan?.collectionId || meal.collectionId;

      if (!collectionId) {
        const fullMeal = this.state.breakfasts.find(m => m.id === meal.id) ||
          this.state.entrees.find(m => m.id === meal.id);
        collectionId = fullMeal?.collectionId;
      }

      if (!collectionId && meal.sku) {
        const fullMealBySku = this.state.breakfasts.find(m => m.variants?.[0]?.sku === meal.sku) ||
          this.state.entrees.find(m => m.variants?.[0]?.sku === meal.sku);
        collectionId = fullMealBySku?.collectionId;
      }

      return {
        id: meal.id,
        quantity: meal.quantity,
        title: meal.title,
        sku: meal.sku,
        subscriptionId: meal.subscriptionId,
        selling_plan: sellingPlan,
        collectionId: collectionId,
        tags: meal.tags,
        handle: meal.handle,
        image: meal.image,
        frequence: meal.frequence || 'recurring',
        type: meal.type,
        variants: [{
          sku: meal.variants[0]?.sku
        }]
      };
    });

    const cleanedMeals = await Promise.all(cleanedMealsPromises);

    const missingCollectionIds = cleanedMeals.filter(m => !m.collectionId);
    if (missingCollectionIds.length > 0) {
      return;
    }

    const missingPlans = cleanedMeals.filter(m => !m.selling_plan);
    if (missingPlans.length > 0) {
      return;
    }

    const url = `${apiUrl}/api/customers/${customerId}/upcomingDeliveries`;
    const customerEmail = window.theme.customerEmail;

    const data = {
      excludeCodes: excludeCodes,
      addressId: addressId,
      editedByUser: true,
      meals: cleanedMeals,
    };

    API.post(CryptoTool.cryptUrl(url, customerEmail, true), data)
      .then(() => {
        if (typeof redirectEditQuantity === "undefined" || redirectEditQuantity === false) {
          window.location.href = window.location.href.split("?")[0];
        } else {
          window.location.href = window.location.origin + "/pages/account-settings";
        }
      })
      .catch((error) => {
        this.setState({
          errorMessage: error.message,
        });
        logSentryError(error);
      });
  };

  render() {
    const {
      isLoaded,
      bundles,
      exclusions,
      breakfasts,
      entrees,
      additionals,
      diets,
      selectedMeals,
      selectedAddIns,
      selectedExclusions,
      selectedDiet,
      dietType,
      toCart,
      limitations,
      configPageUrl,
      dietitian,
      sticky,
      compactHeader,
      programType,
      step,
      charge,
      errorMessage,
      selectedProgram,
    } = this.state;
    const { mode, mealSettings, main_title } = this.props;

    return (
      <>
        {errorMessage && (
          <ErrorMessage
            modalIsOpen={errorMessage.length ? true : false}
            closeErrorModal={this.handleCloseErrorModal}
            message={errorMessage}
          />
        )}

        {mode === "constructor" && (
          <ProgressBarUncontrolled
            selectedMeals={selectedMeals}
            selectedAddIns={selectedAddIns}
            bundles={bundles}
            programType={programType}
            selectedDiet={selectedDiet}
            dietType={dietType}
            dietitian={dietitian}
            step={step}
            limitations={limitations}
          />
        )}

        {step === 1 && (
          <ContentWrap mode={mode}>
            <ContentInner>
              <MealSettings
                exclusions={exclusions}
                diets={diets}
                exclusionChange={this.handleExclusionChange}
                selectedExclusions={selectedExclusions}
                selectedDiet={selectedDiet}
                dietChange={this.handleDietChange}
                sticky={sticky}
                handleCompactModeClick={this.handleCompactModeClick}
                compactHeader={compactHeader}
                mode={mode}
                main_title={main_title}
                dietType={dietType}
              />

              {isLoaded ? (
                <MealList
                  breakfasts={breakfasts}
                  entrees={entrees}
                  selectedMeals={selectedMeals}
                  handleMealChange={this.handleMealChange}
                  selectedDiet={selectedDiet}
                  mode={mode}
                  bundleTitle={this.state.bundleTitle}
                  handlePrevClick={this.handlePrevClick}
                  charge={charge}
                />
              ) : (
                <SkeletonLoader />
              )}
            </ContentInner>

            <Sidebar
              isLoaded={isLoaded}
              selectedMeals={selectedMeals}
              selectedExclusions={selectedExclusions}
              selectedDiet={selectedDiet}
              dietType={dietType}
              handleMealChange={this.handleMealChange}
              hadleClearAll={this.hadleClearAll}
              handleDeleteItem={this.handleDeleteItem}
              toCart={toCart}
              handleCTAClick={this.handleCTAClick}
              limitations={limitations}
              selectedProgram={selectedProgram}
              configPageUrl={configPageUrl}
              dietitian={dietitian}
              handleDietitianChange={this.handleDietitianChange}
              sticky={sticky}
              compactHeader={compactHeader}
              mode={mode}
              handlePrevClick={this.handlePrevClick}
              charge={charge}
              programType={programType}
              mealSettings={mealSettings}
              handleClickEditQuantity={this.handleClickEditQuantity}
              main_title={main_title}
            />
          </ContentWrap>
        )}

        {step === 2 && (
          <ContentWrap>
            <AddIns
              additionals={additionals}
              handleBackClick={this.handleBackClick}
              handleToCheckoutClick={this.handleToCheckoutClick}
              selectedAddIns={selectedAddIns}
              handleMealChange={this.handleAddInsChange}
              handleSaveCharge={this.handleSaveCharge}
              mode={mode}
            />
          </ContentWrap>
        )}
      </>
    );
  }
}

MealSelectorContent.propTypes = {
  customerId: PropTypes.number,
  mealConstructorCollections: PropTypes.object,
  mode: PropTypes.string,
  mealSettings: PropTypes.object,
};

export default MealSelectorContent;